import { Grid, useEventCallback } from '@mui/material';
import { FormikErrors } from 'formik';
import MunicipalityList, { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import { ItalianForm } from 'shell/view-models/italian-form';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { DateTime } from 'luxon';

interface ItalianComponentProps {
  disabled?: boolean;
  isEditMode?: boolean;
  values?: ItalianForm;
  errors?: FormikErrors<ItalianForm>;
  onChange: (key: keyof ItalianForm, value: ItalianForm[keyof ItalianForm]) => void;
  birthday?: DateTime | null;
}

const ItalianComponent = ({
  disabled,
  onChange,
  values,
  isEditMode,
  errors,
  birthday,
}: ItalianComponentProps): React.ReactElement => {
  const handleMunicipalityListChange = useEventCallback(
    (municipality: MunicipalityAnprVM | null) => {
      onChange('municipality', municipality);
    }
  );

  return (
    <Grid
      item
      xs={12}
      container
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={{ xs: 1, md: 0 }}
    >
      <Grid item xs={12} md={4}>
        <MunicipalityList
          required
          value={values?.municipality || null}
          onChange={handleMunicipalityListChange}
          disabled={isEditMode ? false : disabled}
          fromDate={birthday}
          label="Comune di nascita"
          error={Boolean(errors?.municipality)}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Provincia di nascita"
          label="Provincia di nascita *"
          id="province"
          name="province"
          fullWidth
          disabled
          type="text"
          variant="outlined"
          value={values?.province || values?.municipality?.province || ''}
          error={Boolean(errors?.municipality)}
          onChange={(event) => {
            onChange('province', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Località"
          label="Località"
          id="locality"
          name="locality"
          fullWidth
          disabled={isEditMode ? false : disabled}
          type="text"
          variant="outlined"
          value={values?.location || ''}
          onChange={(event) => {
            onChange('location', event.target.value);
          }}
          inputProps={{
            maxLength: '120',
          }}
        />
      </Grid>
    </Grid>
  );
};

ItalianComponent.displayName = 'Italian generality component';

const Italian = memo(ItalianComponent);

export default Italian;
